/**
 * Bead Selector Bridge
 * Connecte les selections de perles au bracelet dynamique
 * - Pattern alternance stricte des perles selectionnees
 * - Breloque au centre du bracelet
 */
(function() {
    'use strict';

    var sizeConfiguration = {
        '6mm': {
            '14cm': 26, '15cm': 27, '16cm': 29, '17cm': 31, '18cm': 33,
            '19cm': 34, '20cm': 36, '21cm': 38, '22cm': 40, '23cm': 42
        },
        '8mm': {
            '14cm': 21, '15cm': 22, '16cm': 23, '17cm': 24, '18cm': 25,
            '19cm': 26, '20cm': 28, '21cm': 29, '22cm': 30, '23cm': 31
        }
    };

    var currentTextures = {};
    var currentBeadSize = '6mm';
    var currentBraceletSize = '17cm';
    var currentBreloqueImage = null;
    var currentBreloqueName = null;

    // Ecouter les changements de perles
    document.addEventListener('beadSelectionChange', function(e) {
        var detail = e.detail || {};
        currentTextures = detail.textures || {};
        currentBeadSize = detail.beadSize || '6mm';
        currentBraceletSize = detail.braceletSize || '17cm';
        renderBracelet();
    });

    // Ecouter les changements de breloque
    document.addEventListener('breloqueChange', function(e) {
        var detail = e.detail || {};
        currentBreloqueImage = detail.image || null;
        currentBreloqueName = detail.name || null;
        updateBreloque(currentBreloqueImage, currentBreloqueName);
    });

    function initBracelet() {
        // Lire l'etat initial si bead-selector.js a deja selectionne des perles
        if (window.beadSelector) {
            var bs = window.beadSelector;
            if (bs.selectedTextures) {
                Object.keys(bs.selectedTextures).forEach(function(k) {
                    if (bs.selectedTextures[k]) currentTextures[k] = bs.selectedTextures[k];
                });
            }
        }
        renderBracelet();
    }

    function renderBracelet() {
        var mediaWrapper = document.querySelector('.product-information__media');
        if (!mediaWrapper) return;

        var sizeConfig = sizeConfiguration[currentBeadSize];
        var beadsNumber = (sizeConfig && sizeConfig[currentBraceletSize]) || 31;

        // Collecter uniquement les textures selectionnees (pattern alternance stricte)
        var textureArray = [];
        Object.keys(currentTextures).sort().forEach(function(k) {
            if (currentTextures[k]) textureArray.push(currentTextures[k]);
        });

        var imageUrls = textureArray.slice();
        if (imageUrls.length > 0) {
            preloadImages(imageUrls, function() {
                generateBracelet(mediaWrapper, textureArray, beadsNumber);
            });
        } else {
            generateBracelet(mediaWrapper, textureArray, beadsNumber);
        }
    }

    function preloadImages(urls, callback) {
        var loaded = 0;
        var total = urls.length;
        if (total === 0) { callback(); return; }
        urls.forEach(function(url) {
            var img = new Image();
            img.onload = img.onerror = function() {
                loaded++;
                if (loaded >= total) callback();
            };
            img.src = url;
        });
    }

    function generateBracelet(mediaWrapper, textureArray, beadsNumber) {
        var existing = mediaWrapper.querySelector('.dynamic-bracelet');
        if (existing) existing.remove();

        // Logique physique réelle :
        // - la taille des PERLES est fixe (6mm ou 8mm), calibrée sur le cadre
        // - c'est le TOUR du bracelet qui grandit avec les cm (14cm petit anneau,
        //   23cm grand anneau), perles identiques.
        // Référence de calibrage : bracelet 6mm/17cm (31 perles) = 70% du cadre.
        // Les grandes combinaisons (8mm/23cm) sont plafonnées à 98% du cadre.
        var containerWidth = mediaWrapper.clientWidth || 600;
        var beadUnit = (containerWidth * 0.70 * Math.PI) / 31;       // perle 6mm à l'écran
        var mmFactor = (currentBeadSize === '8mm') ? (8 / 6) : 1;    // 8mm = perles plus grosses
        var diametreBead = beadUnit * mmFactor;
        var diametreBracelet = (diametreBead * beadsNumber) / Math.PI;

        // Plafond : le bracelet ne doit jamais déborder du cadre
        var maxStage = containerWidth * 0.98;
        var projectedStage = diametreBracelet + diametreBead * 1.18;
        if (projectedStage > maxStage) {
            var shrink = maxStage / projectedStage;
            diametreBead *= shrink;
            diametreBracelet *= shrink;
        }

        // Perspective photo : le bracelet est vu de biais → ellipse.
        // Les perles de devant (bas) sont plus grosses, celles du fond plus petites.
        var ELLIPSE_RATIO = 0.52;   // hauteur de l'ellipse vs largeur (1 = cercle)
        var SCALE_BACK = 0.80;      // taille des perles du fond
        var SCALE_FRONT = 1.18;     // taille des perles de devant

        var rx = diametreBracelet / 2;
        var ry = rx * ELLIPSE_RATIO;

        var stageWidth = diametreBracelet + diametreBead * SCALE_FRONT;
        var stageHeight = ry * 2 + diametreBead * SCALE_FRONT * 1.4;
        var centerX = stageWidth / 2;
        var centerY = stageHeight / 2;

        var dynamicBracelet = document.createElement('div');
        dynamicBracelet.className = 'dynamic-bracelet';
        // lpInlinePos : positionnement inline (imbattable, indépendant du CSS en cache)
        dynamicBracelet.style.cssText =
            '--bracelet-size:' + diametreBracelet + 'px;' +
            '--bead-size:' + diametreBead + 'px;' +
            'width:' + stageWidth + 'px;height:' + stageHeight + 'px;' +
            'position:absolute;left:50%;top:55%;transform:translate(-50%,-50%);margin:0;';

        // ---- Répartition des perles COLLÉES le long de l'ellipse ----
        // On parcourt l'ellipse en distance réelle (pas en angle : l'angle
        // tasse les perles sur les côtés et les écarte en haut). L'espacement
        // local est proportionnel à la taille de la perle à cet endroit
        // (perspective) → contact constant, comme un vrai fil de perles.
        var SAMPLES = 1440;
        var samples = [];
        var totalWeighted = 0;
        var bottomCum = 0;
        var s, th, dsdth, sDepth, w;
        for (s = 0; s < SAMPLES; s++) {
            th = (s / SAMPLES) * Math.PI * 2;
            dsdth = Math.sqrt(
                Math.pow(rx * Math.sin(th), 2) + Math.pow(ry * Math.cos(th), 2)
            ) * (Math.PI * 2 / SAMPLES);
            sDepth = (Math.sin(th) + 1) / 2;
            w = SCALE_BACK + (SCALE_FRONT - SCALE_BACK) * sDepth;
            totalWeighted += dsdth / w;
            samples.push({ th: th, cum: totalWeighted });
            if (th <= Math.PI / 2) bottomCum = totalWeighted;
        }

        // Pas entre perles (en distance pondérée) + léger chevauchement (perles collées)
        var step = totalWeighted / beadsNumber;
        var baseBead = step * 1.06;

        function angleAt(cumTarget) {
            cumTarget = ((cumTarget % totalWeighted) + totalWeighted) % totalWeighted;
            for (var k = 0; k < SAMPLES; k++) {
                if (samples[k].cum >= cumTarget) return samples[k].th;
            }
            return samples[SAMPLES - 1].th;
        }

        // Quand le nombre de perles n'est pas un multiple du motif, la couture
        // (deux perles identiques côte à côte) est inévitable : on fait démarrer
        // le motif à la perle du FOND pour que le doublon soit derrière, pas devant.
        var backIndex = Math.floor(beadsNumber / 2);

        for (var i = 0; i < beadsNumber; i++) {
            // La perle 0 est exactement en bas (breloque) ; les autres suivent
            var angle = angleAt(bottomCum + i * step);
            var x = centerX + rx * Math.cos(angle);
            var y = centerY + ry * Math.sin(angle);

            // Profondeur : 0 = fond (haut), 1 = devant (bas)
            var depth = (Math.sin(angle) + 1) / 2;
            var beadSize = baseBead * (SCALE_BACK + (SCALE_FRONT - SCALE_BACK) * depth);

            var bead = document.createElement('span');
            bead.className = 'dynamic-bracelet__bead';
            bead.style.top = (y - beadSize / 2) + 'px';
            bead.style.left = (x - beadSize / 2) + 'px';
            bead.style.width = beadSize + 'px';
            bead.style.height = beadSize + 'px';
            // Les perles de devant passent devant celles du fond
            bead.style.zIndex = String(10 + Math.round(depth * 100));

            // La perle 0 est la perle du bas (emplacement breloque)
            if (i === 0) {
                bead.setAttribute('data-mid', 'true');
                if (currentBreloqueImage) bead.style.display = 'none';
            }

            // Pattern alternance stricte : cycle uniquement sur les perles selectionnees.
            // Le motif démarre à la perle du fond (backIndex) → la couture est derrière.
            if (textureArray.length > 0) {
                var patternPos = (i - backIndex + beadsNumber) % beadsNumber;
                var textureUrl = textureArray[patternPos % textureArray.length];
                bead.style.backgroundImage = 'url(' + textureUrl + ')';
            }

            dynamicBracelet.appendChild(bead);
        }

        // Breloque : toujours pile en bas (angle pi/2), devant
        var bottomAngle = Math.PI / 2;
        var midX = centerX + rx * Math.cos(bottomAngle);
        var midY = centerY + ry * Math.sin(bottomAngle);
        var breloqueSize = Math.round(diametreBead * SCALE_FRONT * 1.6);

        var breloqueEl = document.createElement('div');
        breloqueEl.className = 'breloque-center';
        breloqueEl.style.top = (midY - breloqueSize / 2) + 'px';
        breloqueEl.style.left = (midX - breloqueSize / 2) + 'px';
        breloqueEl.style.width = breloqueSize + 'px';
        breloqueEl.style.height = breloqueSize + 'px';
        breloqueEl.style.zIndex = '120';
        breloqueEl.style.display = 'none';
        dynamicBracelet.appendChild(breloqueEl);

        mediaWrapper.appendChild(dynamicBracelet);

        // Re-appliquer la breloque si deja selectionnee
        if (currentBreloqueImage) {
            updateBreloque(currentBreloqueImage, currentBreloqueName);
        }
    }

    function updateBreloque(imageUrl, name) {
        var breloqueEl = document.querySelector('.breloque-center');
        var midBead = document.querySelector('.dynamic-bracelet__bead[data-mid="true"]');
        if (!breloqueEl) return;

        if (imageUrl) {
            if (midBead) midBead.style.display = 'none';
            breloqueEl.innerHTML = '<img src="' + imageUrl + '" alt="' + (name || 'Breloque') + '" style="width:100%;height:100%;object-fit:contain;">';
            breloqueEl.style.display = 'block';
        } else {
            if (midBead) midBead.style.display = '';
            breloqueEl.innerHTML = '';
            breloqueEl.style.display = 'none';
        }
    }

    // Re-dessiner quand la fenetre change de taille (le bracelet est en % du cadre)
    var resizeTimer = null;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(renderBracelet, 200);
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBracelet);
    } else {
        initBracelet();
    }
})();
